<template>
<div v-if="post">
  <h1 class="title">{{ $t('term.explanation') }}</h1>

  <h3 class="title is-5">{{ $t('term.question') }}</h3>

  <post-content
    :post="post"
    :is-disp-title="false"
  ></post-content>

  <div class="block mt-6">
    <h3 class="title is-5">{{ $t('term.answer') }}</h3>
    <div
      v-if="post.answerType === 'text'"
      class="block"
    >{{ post.correctAnswerText }}</div>

    <select-type-answers-content
      v-if="post.answerType == 'select'"
      :answers="post.answersHtml"
      :correct-answer="post.correctAnswer"
    ></select-type-answers-content>

  </div>

  <div class="block mt-6">
    <h3 class="title is-5">{{ $t('form.answerExplanation') }}</h3>
    <html-content
      :body="post.answerExplanationHtml"
      class="mt-2"
    ></html-content>

    <ul v-if="'answerExpImages' in post && post.answerExpImages.length > 0">
      <li
        v-for="image in post.answerExpImages"
        :key="image.fileId"
        class="image"
      >
        <fb-img
          :fileId="image.fileId"
          :mimeType="image.mimeType"
          size="raw"
          class="mt-4"
        />
      </li>
    </ul>
  </div>

  <nav
    v-if="post.category"
    class="breadcrumb"
    aria-label="breadcrumbs"
  >
    <ul>
      <li>
        <router-link :to="`/posts/${serviceId}/`">{{ $t('common.posts') }}</router-link>
      </li>
      <li
        v-for="parent in post.category.parents"
      >
        <router-link :to="`/posts/${serviceId}/categories/${parent.slug}`">{{ parent.label }}</router-link>
      </li>
      <li>
        <router-link :to="`/posts/${serviceId}/categories/${post.category.slug}`">{{ post.category.label }}</router-link>
      </li>
    </ul>
  </nav>

  <ul v-if="'tags' in post && post.tags">
    <li
      v-for="tag in post.tags"
      class="is-inline-block mr-2"
    >
      <router-link
        :to="`/posts/${serviceId}/tags/${tag.label}`"
        class="tag"
      >{{ tag.label }}</router-link>
    </li>
  </ul>
</div>
</template>
<script>
import config from '@/config/config'
import { Post, Vote, User } from '@/api'
import PostContent from '@/components/organisms/PostContent'
import HtmlContent from '@/components/atoms/HtmlContent'
import SelectTypeAnswersContent from '@/components/molecules/SelectTypeAnswersContent'
import FbImg from '@/components/atoms/FbImg'
import Comments from '@/components/organisms/Comments'
import VoteUnit from '@/components/organisms/VoteUnit'

export default{
  name: 'Post',

  components: {
    PostContent,
    HtmlContent,
    FbImg,
    Comments,
    VoteUnit,
    SelectTypeAnswersContent,
  },

  data(){
    return {
      post: null,
      answerLabels: ['A', 'B', 'C', 'D'],
    }
  },

  computed: {
    slug() {
      return this.$route.params.slug
    },

    isExecutingAnswer() {
      return this.$store.getters.isExecutingAnswer()
    },

    userAnswerId() {
      if (this.userAnswer == null) return ''
      return this.userAnswer.userAnswerId
    },
  },

  watch: {
  },

  async created() {
    await this.init()
  },

  destroyed() {
  },

  methods: {
    async init() {
      await this.setPost(this.slug)
    },

    async setPost(slug) {
      this.$store.dispatch('setLoading', true)
      try {
        const params = this.previewToken ? { token:this.previewToken } : null
        this.post = await Post.get(this.serviceId, this.slug, params)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err);//!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },
  },
}
</script>

